export default __webpack_public_path__ + "static/media/longmon.8f5a6fcb.svg";